import React, { useEffect, Component, Fragment, useState } from "react";
import Button from '@mui/material/Button';
import IconButton from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Paper, { PaperProps } from '@mui/material/Paper';
import Draggable from 'react-draggable';
import CloseIcon from '@mui/icons-material/Close';
import PortalReactDOM from 'react-dom';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

import { FxmsData } from "../datas/FxData";

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

export function DraggableDialog(props) {

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Button variant="outlined" onClick={handleClickOpen}>
        Open draggable dialog
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          Subscribe
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            To subscribe to this website, please enter your email address here. We
            will send updates occasionally.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Cancel
          </Button>
          <Button onClick={handleClose}>Subscribe</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}



export const FxmsDialog = props => {

  const { open, dialogTitle } = props;
  const [isOpen, setIsOpen] = React.useState(open);

  const handleClose = () => {
    setIsOpen(false);
  };

  console.log('*** FxmsDialog ***', isOpen, props)

  return (
    <>
      {isOpen ? (
        <div>
          <Dialog
            open={isOpen}
            onClose={handleClose}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
          >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">{dialogTitle}</DialogTitle>
            <DialogContentText />
            <DialogContent>{props.children}</DialogContent>
            <DialogActions>
              <Button autoFocus onClick={handleClose}>
                Cancel
              </Button>
              <Button onClick={handleClose}>Subscribe</Button>
            </DialogActions>
          </Dialog>
        </div>
      )
        : null}
    </>
  );
}


/**
 *
 * @param {object} props
 *
 * @returns
 */

export const FxmsContentDashboardDialog = (props) => {

  const { open, closeModal, opObj } = props;
  const fxmsDiv = document.getElementById("fxmsContentComponentDiv");
  const title = props.title ? props.title : props.dialogTitle;

  if (fxmsDiv && open) {

    fxmsDiv.innerHTML = "";

    const fxmsContentDiv = document.createElement("div");
    fxmsContentDiv.id = 'fxmsContentComponentDivChild';
    fxmsContentDiv.className = 'FxContentBoxContent';
    fxmsDiv.appendChild(fxmsContentDiv);

    const ret = PortalReactDOM.createPortal(props.children, fxmsContentDiv);
    return ret;

  }

  return <FxmsPopup open={open} closeModal={closeModal} title={title} opObj={opObj}>
    {props.children}
  </FxmsPopup>;
}


export const FxPopupOpener = props => {

  const [modalOpen, setModalOpen] = useState(false);
  const openRef = props.openRef ? props.openRef : props.openPopup;
  const opObj = props.opObj ? props.opObj : FxmsData.getOpObj(props.opId);
  const title = props.title ? props.title : opObj ? opObj.opTitle : "Thingspire";
  const addr = props.addr ? props.addr : "";
  const oldPopup = "Y";


  console.log('*** FxPopupOpener ***', openRef, props);


  const closeModal = () => {
    setModalOpen(false);
  };
  const openModal = () => {
    setModalOpen(true);
  };

  useEffect(() => {
    if (openRef) {
      if (props.refIndex >= 0) {
        openRef.current[props.refIndex] = openModal;
      } else {
        openRef.current = openModal;
      }
    }
  }, []);


  return (
    <>
      {oldPopup === 'Y' ?
        <FxmsPopup open={modalOpen} closeModal={closeModal} title={title} opObj={opObj} addr={addr}>
          {props.children}
        </FxmsPopup> :
        <FxPopup open={modalOpen} closeModal={closeModal} title={title} opObj={opObj}>
          {props.children}
        </FxPopup>
      }
    </>
  );
}


var POPUP_ID = 0;

export const FxPopup = (props) => {
  const { open, closeModal, opObj } = props;
  const title = props.title ? props.title : opObj ? opObj.opTitle : 'No TITLE';
  const width = opObj ? opObj.maxWidthNum + "px" : "800px";
  const popupId = 'popupPage' + (POPUP_ID++);

  console.log('*** FxPopup ***', title, width, opObj);

  useEffect(() => {
    if (open) {
      openPopup();
    } else {
      closePopup();
    }
  }, [open]);

  function openPopup() {
    document.getElementById(popupId).style.display = 'grid';
  }

  function closePopup() {
    document.getElementById(popupId).style.display = 'none';
  }

  return (
    <div className="FxPopupBg" id={popupId} style={{ display: 'none' }} >
      <div className="FxPopup" style={{ width: width }}>
        <div className="popTitle">
          <span>{title}</span>
          <div className="closeBtn" onClick={function (e) { closeModal(); }}>
            <span>X</span>
          </div>
        </div>

        <div className="popContents">
          {props.children}
        </div>
      </div>
    </div>
  );
};




export const FxmsPopup = (props) => {
  const { open, closeModal, opObj } = props;
  const maxWidth = props.width ? props.width : opObj ? opObj.maxWidth : "lg";
  const title = props.title ? props.title : props.dialogTitle;
  const addr = props.addr ? props.addr : "";

  if ( FxmsData.isDebug ) {
    // console.log('*** FxmsPopup ***', opObj);
  }

  return (
    // 모달이 열릴때 openModal 클래스가 생성된다.
    <>
      <Dialog
        open={open}
        // onClose={closeModal}
        // PaperComponent={PaperComponent}
        // aria-labelledby="draggable-dialog-title"
        // fullWidth={true}
        // disableBackdropClick={true}
        PaperProps={{ sx: { width: "100%" } }}
        maxWidth={maxWidth}
        className="FxmsPopup"

      >
        <DialogTitle id="draggable-dialog-title" className='FxmsPopupTitle'>{title} <span style={{float: "right", fontSize: 16, fontWeight: 300, marginTop: "18px"}}>{addr}</span>
          <IconButton
            aria-label="close"
            onClick={closeModal}
            className="FxDialogClose"
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon sx={{ fontSize: '2.5rem' }} />
          </IconButton>
        </DialogTitle>
        <DialogContentText>
        </DialogContentText>
        <DialogContent>{props.children}</DialogContent>
        {/* <DialogActions>
          <Button autoFocus onClick={closeModal}>Close</Button>
        </DialogActions> */}
      </Dialog>

    </>
  );


};



export const useConfirm = (message = null, onConfirm, onCancel) => {
  if (!onConfirm || typeof onConfirm !== "function") {
    return;
  }
  if (onCancel && typeof onCancel !== "function") {
    return;
  }

  const confirmAction = () => {
    if (window.confirm(message)) {
      onConfirm();
    } else {
      onCancel();
    }
  };

  return confirmAction;
};


export const FxAlert = (props) => {
  const { snackbar } = props;
  const [open, setOpen] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [message, setMessage] = React.useState("");

  // console.log("*** FxSnackbar ***", message);

  useEffect(() => {
    snackbar.current = function (message, error) {
      setError(error);
      setMessage(message);
      setOpen(true);
    };
  }, []);

  const closeSnackbar = () => {
    setOpen(false);
  };

  const action = (
    <>
      {/* <Button color="secondary" size="small" onClick={handleClose}>
        UNDO
      </Button> */}
      <Alert severity={error ? 'error' : 'success'} sx={{ width: "100%" }}>{message}</Alert>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={closeSnackbar}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </>
  );

  return (
    <div>
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={closeSnackbar}
        action={action}
        message=""
        width="xs"
      >
      </Snackbar>
    </div>
  );

};

/**
 *
 * @param {*} props
      * @returns
      */
export const FxConfirm = (props) => {
  const { fxConfirm } = props;
  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const retCall = React.useRef(null);

  const ok = () => {
    setOpen(false);
    console.log("FxConfirm ok", retCall);
    if (retCall && retCall.callback) {
      retCall.callback(true);
    }
  };
  const cancel = () => {
    setOpen(false);
    console.log("FxConfirm cancel", retCall);
    if (retCall && retCall.callback) {
      retCall.callback(false);
    }
  };
  const call = (message, callback) => {
    console.log("FxConfirm call", callback);
    retCall.callback = callback;
    setMessage(message);
    setOpen(true);
  }

  useEffect(() => {
    console.log("FxConfirm callback changed", retCall);
  }, [retCall]);

  useEffect(() => {
    fxConfirm.current = call;
  }, []);

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth="xs"
      className="FxConfirm"
    >
      {/* <DialogTitle id="alert-dialog-title">
          {title}
        </DialogTitle> */}
      <DialogContent>
        <DialogContentText id="alert-dialog-description" className="Message">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={ok} autoFocus className="FxButton">확인</Button>
        <Button onClick={cancel} className="FxButton">취소</Button>
      </DialogActions>
    </Dialog>
  );
}

/**
 *
 */
export class FxWindow {


  static setSnackbar(snackbar) {
    FxWindow.snackbar = snackbar;
  }

  static setFxConfirm(fxConfirm) {
    FxWindow.fxConfirm = fxConfirm;
  }

  static alert(message, error = false) {
    FxWindow.snackbar.current(message, error);
  }

  static confirm(message, callback) {
    if ( FxWindow.fxConfirm && FxWindow.fxConfirm.current ) {
      FxWindow.fxConfirm.current(message, callback);
    } else {
      //const bret = confirm(message);
      //callback(bret);
    }
  }

  static showNavigator(s) {
    const el = document.getElementById("FXMS_NAVIGATOR");
    if ( el )
      el.innerHTML = "<span>" + s + "</span>";
  }
  static showSiteName(s) {
    const el = document.getElementById("FXMS_SITE_NAME");
    if ( el )
      el.innerHTML = s;
  }

}



/**
 *
 * @param {*} props
      * @returns
      */
export const FxOpenContent = props => {

  const { openRef } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const [index, setIndex] = useState(0);

  console.log("*** VupData FxOpenContent ***", props);


  const closeModal = () => {
    setModalOpen(false);
  };

  const openModal = () => {
    if (modalOpen) {
      setIndex(index + 1);
    } else {
      setModalOpen(true);
    }
  };

  useEffect(() => {
    openRef.current = openModal;
  }, []);

  return (
    <>
      <FxmsContentDashboardDialog open={modalOpen} closeModal={closeModal} dialogTitle={""} index={index}>
        {props.children}
      </FxmsContentDashboardDialog>
    </>
  );

}
